import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

/* -------------------
   Global font faces
   ------------------- */
const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'LexendMega';
    src: url('../assets/fonts/LexendMega-Regular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'AnybodyMedium';
    src: url('../assets/fonts/Anybody-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
`;

/* -------------------
   Breakpoints
   ------------------- */
const breakpoints = {
  mobile: '40rem', // 640px
  tablet: '64rem', // 1024px
};

/* -------------------
   Base layout
   ------------------- */
const Page = styled.article`
  max-width: 110rem; /* 1440px */
  margin: 0 auto;
  background: #ffffff;
  font-family: 'AnybodyMedium', 'Anybody', sans-serif;
  color: #000;
  overflow-x: hidden;
`;

const WideImg = styled.img`
  width: 50%;
  height: auto;
  display: block;
margin: 0 auto
`;
const HeaderImg = styled.img`
  width: 100%;
  height: auto;
  display: block;
  margin: 0;
`;
/* -------------------
   Decorative burger
   ------------------- */
const Burger = styled.div`
  position: absolute;
  top: 2.125rem; /* 34px */
  left: 1.5rem;  /* 24px */
  display: flex;
  flex-direction: column;
  gap: 0.75rem; /* 12px */
  z-index: 2;

  span {
    display: block;
    width: 3rem;   /* 48px */
    height: 0.25rem; /* 4px */
    background: #ff5e5e;
  }

  @media (max-width: ${breakpoints.mobile}) {
    top: 1.25rem;
    left: 1rem;
    gap: 0.5rem;

    span {
      width: 2rem;
      height: 0.1875rem;
    }
  }
`;

/* -------------------
   Text styles
   ------------------- */
const Credits = styled.p`
  position: relative;
  margin: -4rem auto 0;
  padding: 0 1rem;
  max-width: 18rem;
  text-align: center;
  color: #ffffff;
  font-family: 'LexendMega', sans-serif;
  font-weight: 400;
  font-size: clamp(0.875rem, 1.2vw, 0.9375rem);
`;

const Tagline = styled.h2`
  font-family: 'Anybody', sans-serif;
  font-weight: 700;
  color: #ff4b4b;
  font-size: clamp(1.25rem, 1.6vw, 1.5625rem);
  line-height: 1.35;
  max-width: 69rem;
  margin: 2.5rem auto;
  text-align: center;
`;
const Tagline2 = styled.h2`
  font-family: 'Anybody', sans-serif;
  font-weight: 700;
  color:
  rgb(0, 0, 0);
  font-size: clamp(1.25rem, 1.6vw, 1.5625rem);
  line-height: 1.35;
  max-width: 69rem;
  margin: 2.5rem auto;
  text-align: center;
`;

const Para = styled.p`
  font-family: 'AnybodyMedium', 'Anybody', sans-serif;
  font-weight: 400;
  font-size: clamp(1rem, 1.6vw, 1.5625rem);
  line-height: 1.35;
  max-width: 76.625rem; /* 1226px */
  margin: 1.5rem auto;
  text-align: center;
`;

const Highlight = styled.span`
  font-weight: 700;
`;

const PhotoCredit = styled.p`
  text-align: center;
  color: #ff4b4b;
  font-family: 'Anybody', sans-serif;
  font-weight: 700;
  font-size: clamp(1.125rem, 1.25vw, 1.25rem);
  line-height: 1.35;
  margin: 0.3rem auto;
`;

/* -------------------
   Spotify iframe
   ------------------- */
   const SpotifyFrame = styled.iframe`
   display: block;
   border-radius: 12px;
   width: 100%;
   height: 30rem;
   max-width: 140ch;
   margin: 3rem auto;
 `;
 

/* -------------------
   Footer
   ------------------- */
   const FooterBar = styled.footer`
   background: #000;
   padding: clamp(3rem, 1vh, 3rem) 0;
   text-align: center;
 
   h1 {
     font-family: 'AnybodyBlack', 'Anybody', sans-serif;
     color: #fff;
     font-size: clamp(2.6rem, 8vw, 8rem);
     font-weight: 900;
     margin: 0;
     line-height: 1;
   }
 `;
/* ===============================================================
   Component
   =============================================================== */
export default function NightOut() {
  return (
    <Page>
      <GlobalStyles />

      {/* Header section */}
      <div style={{ position: 'relative' }}>
        <HeaderImg src="/assets/nightout1.png" alt="Smashing club crowd" />
      </div>
      <br />

      {/* Tagline */}
      <Tagline>
        GABRIEL MEALOR‑PRITCHARD CHATS WITH LEGENDARY DJ AND FOUNDER OF THE ICONIC
        ‘SMASHING’ CLUB, MARTIN GREEN, TO DELVE INTO THE LATE‑NIGHT ENERGY, CULTURAL
        IMPACT, AND PERSONAL MEANING BEHIND THE MUSIC THAT DEFINED A NEW‑WAVE SCENE.
      </Tagline>
        <br />
        <br />
      {/* Main portrait */}
      <WideImg src="/assets/nightoutmain.png" alt="Martin Green portrait" />
      <PhotoCredit>PHOTOGRAPHY CREDITS TO DAVE SWINDELLS</PhotoCredit>

      {/* Intro paragraphs */}
      <Para>
      Described by esteemed journalist Alix Sharkey in 2010 as "London’s fabbest, silliest, unlikeliest and most exhilarating Friday night,” DJ and curatorial genius Martin Green's Smashing was the epitome of the London club scene in the early 90s and "a rebellion against the dominance of House music," Green reveals. Occupying what was better known as Eve's club on Regent Street, Smashing was a hotspot for the unapologetically extravagant and those with a fashion-forward focus. A defiant space with great music and great fashion.
      </Para>
      <Para>
        Smashing grew out of the iconic 1980s clubland scenes and was synonymous with those who
        characterised it, with notable clientele including the darlings of BritPop and the defiant
        Leigh Bowery.
      </Para>



      <Para>
        Green had one aim in mind when opening Smashing: to have fun. “Smashing was an incredible
        explosion of ideas, personality and energy,” enthuses Green, animatedly listing some of the
        big moments that occurred behind the doors of the acclaimed hangout. “Courtney Love was
        crowned May Queen, Oasis requested we play their new release <em>Shakermaker</em> and then
        danced around to it. Elastica filmed a video there and Pulp placed a photo of our illuminated
        dancefloor on the cover of <em>Disco 2000</em>.” Oh, and if that wasn't enough! “Leigh Bowery's
        band Minty gave their first performance there!” Clearly, the space was rife with the talent and
        unlimited opportunities that only a truly uninhibited night at Smashing could bring.
      </Para>



      <Para>
        A melting pot of culture and taste, Smashing was a place where you could immerse yourself in an
        unexpected eclectic mix of a glam, Punk, Mod, Soundtracks, Indie, Rock, Psychedelia, Electro, and
        New Wave,” reminisces Green, as he describes the soundscape of the basement concealed beneath one
        of central London's busiest streets. The music didn't just entertain, it told tales… stories of
        subcultures clashing and coalescing, of forgotten tracks resurrected, and of acceptance and
        belonging. All in this underground refuge for rebels looking for a good time.
        <br />
        <br />
      </Para>
            {/* Second image */}
            <WideImg src="/assets/nightout2.png" alt="Smashing club dancefloor" />
            <PhotoCredit>PHOTOGRAPHY CREDITS TO DAVE SWINDELLS</PhotoCredit>
      <Para>
      <br />
        “Fashion at that time was about dressing down in a rave or a grunge style. We were the opposite. We
        were about dressing up,” Green explains. “We attracted open‑minded misfits, most of whom scoured
        charity shops and markets for vintage clothes and accessories,” he adds. There's a clear distinction
        here between the regular and irregular, the idiosyncratic individuals, and those who went along with
        the crowds. “The only brands people cared about were vintage ones from the ’60s and ’70s,” says Green.
        In terms of clobber, the club was more than a fashion statement – it was resistance in the name of
        style. Smashing‑goers declared individuality in a city so swept up in fleeting trends.
      </Para>


      <Para>
        While mainstream crowds embraced the dishevelled ease of rave and grunge, Green and his loyal crowd
        leaned towards flamboyance and eccentricity. Though now many years on, Green mentions that he is “still
        excited by fashion, especially mavericks like Charles Jeffrey, Matti Bovan, Craig Green, John Skelton
        and Benedict Lamb,” again, experimental artists and designers that push boundaries. Like all good things,
        the days of Smashing had to come to an end, but its legacy still lives on, not least in the vivid mind of
        its founder.
      </Para>
      <Para>
        And it’s this connection between fashion and music that makes Green's contribution so crucial to the premise
        of this article. The owner of the hit ’90s club has been invited to DJ for Prada at their events across Paris,
        Milan, and Rome, but what was on the playlist? “I played lots of lounge music and film soundtracks,” he says,
        adding, “Tracks like <em>Nel Mio Orto</em> by Gina Lollobrigida, <em>Pane Marmellata e Me</em> by Ilona Staller and
        <em> Hurry to Me</em> by Ennio Morricone.” Which are available to listen to below.
      </Para>
      <Para>
        Separately, when it comes to creating music for fashion, Green is inspired by cinema, and says, “I've always
        loved film music, so look at creating soundtracks for a fashion show by taking a similar cinematic approach.”
        Mentioning that he wants the experience of a fashion show he has scored for to feel like it is happening “both
        live and in a movie, an aural combination of theatre and film.”
      </Para>
      <Para>
        Aside from Smashing, Green would frequent Taboo when it had just started “as an 18‑year‑old student,” describing
        it as an “incredible scene of flamboyance and outrageousness presented with an unpredictable, diverse soundtrack.”
        Similarly to the persona of Bowery, the club exuded extravagance and helped shape a future that Smashing
        could soon open up into.
      </Para>
      <Para>
        Green was granted the amazing opportunity to craft the soundscape for the <em>Outlaws</em> exhibition held in the Fashion
        and Textiles Museum, London. He had one aim in mind, to reimagine Leigh Bowery through sound, “to evoke that sense of
        surprise, creativity, invention and outrage,” Bowery was known for. He did this by compiling “tracks I remember
        hearing in 1980s clubs,” the true essence of the time.
      </Para>
      <br />
      <br />
      {/* Third image */}
      <WideImg src="/assets/nightout3.png" alt="Vintage club flyer" />
      <PhotoCredit>PHOTOGRAPHY CREDITS TO DAVE SWINDELLS</PhotoCredit>
      <Para>
        I asked Green if he could describe Leigh Bowery by only using three words. “Enormous.
        Exhilarating. Unpredictable,” he replied with an air of certainty. Three fitting words to describe the larger‑than‑life
        personality of the Australian‑born performance artist who embodied London's ’80s avant‑garde scene, and a muse of
        renowned artist Lucien Freud.
      </Para>
      <Para>
        In the end, Martin Green's Smashing wasn't just a club; it was a cultural landmark and a good old riot! A mixture of
        style and spirit that London's rebellious youth adored. It was a place where music and fashion collided. Green's
        passions continue to thrive through his Soho Radio show, and by his involvement in the esteemed Tate Modern
        exhibitions he has worked so closely with. The artist and DJ has proven that the most exciting cultural moments often
        emerge from chaos and the fearless acceptance of being true to oneself. Smashing may not be around today, but to those
        who visited, it will stay with them forever.
        <br />
        <br />
      </Para>
      {/* Fourth image */}
      <WideImg src="/assets/nightout4.png" alt="Smashing club memorabilia" />
      <PhotoCredit>PHOTOGRAPHY CREDITS TO DAVE SWINDELLS</PhotoCredit>
      <br />
      {/* Tracklist section */}
      <Tagline2>MARTIN GREEN SELECTS HIS CURRENT TOP THREE FAVOURITE TRACKS AND GIVE US THE RUNDOWN ON WHY THEY WERE CHOSEN.
      GIVE THEM A LISTEN BELOW:</Tagline2>
      <br />
      <Para>
        <Highlight>‘Black Rite’ by Mandingo</Highlight>
        <br />
        <br />“It was a favourite at Smashing and once when I played it Tris Penna asked me what it was and I told him it was from 1973 and owned by EMI where he worked in A&R. Two days later we had a meeting and started putting together <em>The Sound Gallery</em> album, which was released in 1995 and launched the ’90s lounge music revival.”
      </Para>
      <br />
      <Para>
        <Highlight>‘Queen Bitch’ by David Bowie</Highlight>
        <br />
        <br />“Never failed to ignite the Smashing dancefloor and was a favourite with Leigh Bowery, Pam Hogg, Pulp and Blur. I first heard it aged 13 and still adore it. It's outrageous pop.”
      </Para>
      <br />
      <Para>
        <Highlight>‘Ping Pong’ by Stereolab</Highlight>
        <br />
        <br />“One of those original ’90s tracks with a ’60s psychedelic feel which people absolutely loved at Smashing. It cleverly combined pop with politics and still sounds great today.”
      </Para>

      {/* Spotify playlist */}
      <SpotifyFrame
        src="https://open.spotify.com/embed/playlist/5VMKVTyJQfeIaJtAe7njXE?utm_source=generator"
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />

      {/* Footer */}
      <FooterBar>
        <h1>RIFF MAGAZINE</h1>
      </FooterBar>
    </Page>
  );
}
